import { Component, OnInit } from '@angular/core';
import { HomeService } from '../../services/home.service';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { WarehouseService } from '../../services/warehouse.service';
// import { ImplantDetailModalComponent } from '../../warehouses/modals/implant-detail-modal/implant-detail-modal.component'
import { AddImplantModalComponent } from './add-implant-modal/add-implant-modal.component';
import { Router, NavigationEnd } from '@angular/router';

interface WarehouseData {
  active_stocks: number;
  expiring_stocks: number;  
  expired_stocks: number; 
}

@Component({
  selector: 'app-stock-warehouse',
  templateUrl: './stock-warehouse.component.html',
  styleUrls: ['./stock-warehouse.component.scss', '../../../app.component.scss']
})

export class StockWarehouseComponent implements OnInit{

  activeTab: string = 'warehouse';
  product: any;
  public warehouseId = "";
  public implantProducts: any = [];
  public isImplantProducts: boolean = false;
  public implantType = "";
  
  public totalPages: number = 0;
  public currentPage: number = 1;
  
  public totalImplants: number = 0;

  public searchInput: string = "";
  public encodedSearchInput: string = "";


  public isSearch = false;
  public isFilter = false;
  public isFilterResult = true;
  
  public expirySortValue:string = "";
  public orderBy:string = "asc";


  constructor(private route: ActivatedRoute,public warehouseService: WarehouseService,public dialog: MatDialog,public homeService: HomeService,private router: Router) { }

  public stocks:any= [];
  public stockDetails : any = []

  stockNames: WarehouseData = {
    active_stocks: 10,
    expiring_stocks: 0, 
    expired_stocks: 0
  };

  ngOnInit(): void {
    this.getWarehouseDetails()
    // this.getImplants();
  }

  openAddProductDialog(warehouseId: string){
    const dialogRef = this.dialog.open(AddImplantModalComponent, {
      data: {
        warehouseId
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
      }
    });
  }

  getWarehouseDetails(): void{
    this.homeService.getWarehouseDetails().subscribe( 
      (response: any) => {
        this.stockNames = response.data;
        console.log('Warehouse details:', this.stockNames);
      },
      (error) => {
        console.error('Error fetching store name:', error);
      }
    );
  } 

  updateActiveTab(): void {
    const currentUrl = this.router.url;
    if (currentUrl.includes('home/stores')) {
      this.activeTab = 'stores';
    } else if (currentUrl.includes('home/warehouses')) {
      this.activeTab = 'warehouses';
    } else if (currentUrl.includes('home/alerts-notify')){
      this.activeTab = 'alerts';
    }
  }

  setActiveTabs(tab: string): void {
    this.activeTab = tab;
    // Update route based on active tab
    switch (tab) {
      case 'alerts':
        this.router.navigate(['home/alerts-notify']);
        break;
      case 'stores':
        this.router.navigate(['home/stores']);
        break;
      case 'warehouse':
        this.router.navigate(['home/warehouses']);
        break;
      default:
        break;
    } 
  }

}
  